import UploadRegimeProofError from './UploadRegimeProofError';
class RegimeProofEmpty extends UploadRegimeProofError {
    constructor(options) {
        super('Fiscal Regime proof has not content', options);
    }
}
export default RegimeProofEmpty;
